module.exports = __webpack_public_path__ + "static/media/cruise_bingo.71bfe36d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/cruise_bingo.png
// module id = 301
// module chunks = 0